import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Heading, Map, IconArrowHead } from '../../components';

import css from './ListingPage.module.css';

/**
 * The SectionMapMaybe component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {propTypes.latlng} [props.geolocation] - The geolocation
 * @param {propTypes.uuid} props.listingId - The listing id
 * @returns {JSX.Element} section map maybe component
 */
class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: false, showSection: true };
  }

  render() {
    const { className, rootClassName, geolocation, publicData, listingId, mapsConfig } = this.props;

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';
    const classes = classNames(rootClassName || css.section, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: geolocation };
    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    const { showSection } = this.state;

    return (
      <section className={classes} id="listing-location">
        <Heading
          as="h2"
          rootClassName={css.sectionTitle}
          onClick={() => this.setState({ showSection: !showSection })}
        >
          <FormattedMessage id="ListingPage.locationTitle" />
          <IconArrowHead direction={showSection ? "up" : "down"} />
        </Heading>
        {showSection && (
          <>
            {this.state.isStatic ? (
              <button
                className={css.map}
                onClick={() => { this.setState({ isStatic: false }) }}
              >
                {map}
              </button>
            ) : (
              <div className={css.map}>{map}</div>
            )}
          </>
        )}
      </section>
    );
  }
}

export default SectionMapMaybe;
